:host {
	display: block;
}

.zds-collapsible {
	display: block;

	&__panel {
		height: 0;
		overflow: hidden;

		&:not(.no-transition) {
			transition: height var(--zds-transition-md);
		}
	}

	&__content {
		-webkit-box-orient: vertical;
		// Used to place ellipsis after a certain number of lines
		// Despite their -webkit- vendor prefixes, these properties actually have good cross-browser support
		// Browser support: https://caniuse.com/mdn-css_properties_-webkit-line-clamp
		// Use case explanation: https://css-tricks.com/almanac/properties/l/line-clamp/
		display: -webkit-box;
		overflow: hidden;

		&--mirror {
			height: 0;
			overflow: hidden;
		}
	}
}
